import type { LocaleMessages } from 'shared-types';

type JobMessages = {
  failure: string;
  // replaces `failure` for error codes the admin can act on
  failureByErrorCode?: Record<string, string>;
  success: string;
};

/**
 * Returns localised success/failure message strings for the given job type,
 * plus failure messages for specific error codes where a type has them.
 * Falls back to generic messages for any unrecognised type.
 */
const getJobTypeMessages = (
  messages: LocaleMessages,
  type: string
): JobMessages => {
  switch (type) {
    case 'course-generation':
      return {
        failure: messages.notificationsTextCourseGenerationFailed,
        failureByErrorCode: {
          cannot_build_course:
            messages.backgroundJobCourseGenerationCannotBuildCourse,
          file_missing: messages.backgroundJobCourseGenerationFileMissing,
          quota_exceeded: messages.aiToolsQuotaExceeded
        },
        success: messages.notificationsTextCourseGenerationReady
      };
    case 'course-quality-evaluation':
      return {
        failure: messages.backgroundJobCourseEvaluationFailure,
        success: messages.backgroundJobCourseEvaluationSuccess
      };
    case 'moodle-import':
      return {
        failure: messages.backgroundJobMoodleImportFailure,
        success: messages.backgroundJobMoodleImportSuccess
      };
    default:
      return {
        failure: messages.backgroundJobGenericFailure,
        success: messages.backgroundJobGenericSuccess
      };
  }
};

export default getJobTypeMessages;
